module.exports = __webpack_public_path__ + "static/media/img_Benchmarking405.fb476815.png";